// @ts-check
import { z } from "zod";

const envVariables = z.object({
  VUE_APP_BASE_URL: z.string(),
  VUE_APP_GOOGLE_MAPS_API_KEY: z.string(),
  VUE_APP_NAME: z.string(),
  VUE_APP_ROBOTS_META: z.string(),

  VUE_APP_CART_PATIENT_URL: z.string(),
  VUE_APP_SOCKET_HOST: z.string().min(1),

  NODE_ENV: z.enum(["production", "development"])
});

export const env = envVariables.parse(process.env);
